import { render, staticRenderFns } from "./SendGod.vue?vue&type=template&id=20d0cf2a&scoped=true&"
import script from "./SendGod.vue?vue&type=script&lang=js&"
export * from "./SendGod.vue?vue&type=script&lang=js&"
import style0 from "./SendGod.vue?vue&type=style&index=0&id=20d0cf2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0cf2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d0cf2a')) {
      api.createRecord('20d0cf2a', component.options)
    } else {
      api.reload('20d0cf2a', component.options)
    }
    module.hot.accept("./SendGod.vue?vue&type=template&id=20d0cf2a&scoped=true&", function () {
      api.rerender('20d0cf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/SendGod.vue"
export default component.exports